export function resolveFileUrl(path, baseUrl = '') {
  if (!path) return ''

  const value = String(path).trim()
  if (!value) return ''
  if (/^(https?:)?\/\//i.test(value)) return value
  if (/^(data|blob):/i.test(value)) return value

  const configuredBase = baseUrl || process.env.VUE_APP_API_URL || process.env.VUE_APP_API_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : '')
  const cleanBase = String(configuredBase || '').replace(/\/+$/, '').replace(/\/api$/i, '')
  const cleanPath = value.replace(/^\/+/, '').replace(/^api\//i, '')

  if (!cleanBase) {
    return cleanPath ? `/${cleanPath}` : ''
  }

  return cleanPath ? `${cleanBase}/${cleanPath}` : cleanBase
}

export default resolveFileUrl
